import React from 'react';
import { Star, AlertTriangle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface PriorityStarsProps {
    priority: 'Laag' | 'Normaal' | 'Hoog' | 'Kritiek';
}

export const PriorityStars: React.FC<PriorityStarsProps> = ({ priority }) => {
    const getPriorityDisplay = () => {
        switch (priority) {
            case 'Laag':
                return {
                    stars: 1,
                    color: 'text-gray-400',
                    label: 'Lage prioriteit'
                };
            case 'Normaal':
                return {
                    stars: 2,
                    color: 'text-yellow-500',
                    label: 'Normale prioriteit'
                };
            case 'Hoog':
                return {
                    stars: 3,
                    color: 'text-orange-500',
                    label: 'Hoge prioriteit'
                };
            case 'Kritiek':
                return {
                    stars: 0,
                    color: 'text-red-600',
                    label: 'Kritieke prioriteit'
                };
            default:
                return {
                    stars: 2,
                    color: 'text-yellow-500',
                    label: 'Normale prioriteit'
                };
        }
    };

    const { stars, color, label } = getPriorityDisplay();

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <div className="flex items-center gap-0.5">
                        {stars === 0 ? (
                            <AlertTriangle className={`w-4 h-4 ${color}`} fill="currentColor" />
                        ) : (
                            Array.from({ length: stars }).map((_, i) => (
                                <Star key={i} className={`w-4 h-4 ${color}`} fill="currentColor" />
                            ))
                        )}
                    </div>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{label}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
